import { addQueryParamsToUrl } from './urlUtils';

export const withPaginationTitle = (title: string, currentPage?: number): string => {
    if (currentPage === undefined || !Number.isInteger(currentPage) || currentPage <= 1) {
        return title;
    }

    return `${title} - sida ${currentPage}`;
};

export const getRobotsContent = (noIndex?: boolean, noFollow?: boolean) => {
    if (noIndex && noFollow) {
        return 'NOINDEX,NOFOLLOW';
    }

    if (noIndex) {
        return 'NOINDEX';
    }

    if (noFollow) {
        return 'NOFOLLOW';
    }

    return undefined;
};

export const getCanonical = ({ path, page }: { path: string; page?: number }) => {
    const url = new URL(path, window.location.origin).toString();

    return Number.isInteger(page) && page !== 1
        ? addQueryParamsToUrl(url, { page: String(page) })
        : url;
};

export const getNextPage = (currentPage: number) => {
    const searchParams = new URLSearchParams();
    searchParams.set('page', (currentPage + 1).toString());

    const newUrl = `${
        window.location.origin + window.location.pathname
    }?${searchParams.toString()}`;

    return newUrl;
};

export const getPrevPage = (currentPage: number) => {
    const searchParams = new URLSearchParams();
    const prevPage = currentPage - 1;
    if (prevPage > 1) {
        searchParams.set('page', prevPage.toString());
    } else {
        searchParams.delete('page');
    }
    const stringifiedParams = searchParams.toString();

    const newUrl =
        window.location.origin +
        window.location.pathname +
        (stringifiedParams ? `?${searchParams.toString()}` : '');

    return newUrl;
};
